import request from '@/api/request'

// 我的申请 基本信息申报数据保存
export const save = (data) => {
    return request({
        url: '/project/doSubmit',
        method: 'POST',
        params: data
    })
}
// 我的申请 个人信息数据保存
export const userInfoAdd = (data) => {
    return request({
        url: '/apply-user/doSubmit',
        method: 'POST',
        params: data
    })
}
//  我的申请 预期成果数据保存
export const argumentAdd = (data, params) => {
    return request({
        url: '/research-result/addBatch',
        method: 'POST',
        data: data,
        params: params
    })
}
//  我的申请 课题论证数据保存
export const researchAdd = (data) => {
    return request({
        url: '/project-demonstration/doSubmit',
        method: 'POST',
        data: data
    })
}
//  我的申请 推荐人意见数据保存
export const refereeAdd = (data, params) => {
    return request({
        url: '/referee-advice/addBatch',
        method: 'POST',
        data: data,
        params: params
    })
}
//  我的申请 所在单位意见数据保存
export const companyAdd = (data) => {
    return request({
        url: '/company-advice/doSubmit',
        method: 'POST',
        params: data
    })
}
//  我的申请 委员会建议立项数据保存
export const expertsAdd = (data) => {
    return request({
        url: '/experts-advice/doSubmit',
        method: 'POST',
        params: data
    })
}
//  我的申请 我的项目渲染
export const queryByApplyId = (data) => {
    return request({
        url: '/project/queryByApplyId',
        method: 'GET',
        params: data
    })
}
//  我的申请 我的项目渲染
export const applyId = (data) => {
    return request({
        url: '/apply-user/query/id',
        method: 'POST',
        params: data
    })
}
//  项目申报汇总
export const projectQuery = (data) => {
    return request({
        url: '/project/query',
        method: 'POST',
        params: data
    })
}
//  根据用户id查询信息
export const queryApplyInfoByUserId = (data) => {
    return request({
        url: '/apply-user/queryApplyInfoByUserId',
        method: 'POST',
        params: data
    })
}
//  根据用户id查询信息
export const date = (data) => {
    return request({
        url: '/apply-period/query/date',
        method: 'POST',
        params: data
    })
}
//  申请人重置密码
export const setInitialPassword = (data) => {
    return request({
        url: '/apply-user/setInitialPassword',
        method: 'POST',
        params: data
    })
}
export const  getApplyInfoByProjectId = (data) => {
    return request({
        url: '/apply-user/queryApplyInfoByprojectId',
        method: 'POST',
        params: data
    })
}
export const projectDoConfirm = (data) => {
    return request({
        url: '/project/doConfirm',
        method: 'POST',
        params: data
    })
}

export const getCurrentProjectApply = (data) => {
    return request({
        url: '/project/getCurrentProjectApply',
        method: 'GET',
        params: data
    })
}

export const getUnfinishedProject = (data) => {
    return request({
        url: '/project/getUnfinishedProject',
        method: 'GET',
        params: data
    })
}